
/**
 * Label, control and error of one form field, for controls that bring none of
 * their own (`FormSelect`, `SearchableSelect`). `Input` labels itself and does
 * not need this.
 *
 * The label points at the control by `htmlFor` when it has an id, so the control is announced by
 * its field name rather than by whatever its current value happens to be.
 */
function FormField({ id, label, error, helperText, children }) {
  return (
    <div className="flex flex-col gap-1.5">
      {id ? (
        <label htmlFor={id} className="text-sm font-medium text-content-secondary">
          {label}
        </label>
      ) : (
        <span className="text-sm font-medium text-content-secondary">{label}</span>
      )}
      {children}
      {error ? (
        <p role="alert" className="text-xs text-red-500">
          {error}
        </p>
      ) : helperText ? (
        <p className="text-xs text-content-muted">{helperText}</p>
      ) : null}
    </div>
  );
}

export default FormField;
